import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class CurrencySearchParams extends SearchParamsBase {
  initialize() {
    this.Code = "";
    this.Description = "";
  }

  static fieldsInSearchBox = [

    { fieldName: "Code", label: "Currency Code", className: "col", type: InputTypesEnum.Text },
    { fieldName: "Description", label: "Currency Name", className: "col", type: InputTypesEnum.Text },
  ];

  static iconName = "fa-solid fa-search";
  static saveType = "CurrencySearchParams";

}